var _topupComponent$isDec, _getWindow;
import React from 'react';
import { getIsDecoupled, getWindow } from "../utils/window";
import { TopUpBalanceComponent } from "./components/Root/TopUpBalanceComponent";
import { DecoupledTopUpBalanceSource } from "./components/Decoupled/DecoupledTopUpBalanceSource";
import { findFirst } from "./utils/utils";
import { DecoupledTopUpBalanceTarget } from "./components/Decoupled/DecoupledTopUpBalanceTarget";

// Полифилл для React.useId
// @ts-expect-error useId
React.useId =
// @ts-expect-error useId
typeof (React === null || React === void 0 ? void 0 : React.useId) === 'function' ? React.useId : function () {
  return Math.random().toString(36).slice(2);
};

// Полифилл для React.useInsertionEffect
// @ts-expect-error useId
React.useInsertionEffect =
// @ts-expect-error useId
typeof (React === null || React === void 0 ? void 0 : React.useInsertionEffect) === 'function' ? React.useInsertionEffect : React.useEffect;
var isDecoupled = (_topupComponent$isDec = (_getWindow = getWindow()) === null || _getWindow === void 0 || (_getWindow = _getWindow.topupComponent) === null || _getWindow === void 0 ? void 0 : _getWindow.isDecoupled) !== null && _topupComponent$isDec !== void 0 ? _topupComponent$isDec : false;

// Выбор компонента в зависимости от режима работы
export var TopUpBalance = findFirst([!!getIsDecoupled() && DecoupledTopUpBalanceSource,
// отдельный бандл
isDecoupled && !getIsDecoupled() && DecoupledTopUpBalanceTarget,
// ставим компонент который общается с бандлом
TopUpBalanceComponent // обычный случай
]);
export default TopUpBalance;